import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import SignaturePad from 'signature_pad';
import { BillingService } from 'src/app/services/core/billing/billing.service';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { UploadService } from 'src/app/services/core/documents/upload.service';
import { base64ToFile } from 'src/app/utils/common.utils';

@Component({
  selector: 'app-trip-signature-modal',
  templateUrl: './trip-signature-modal.component.html',
  styleUrls: ['./trip-signature-modal.component.css']
})
export class TripSignatureModalComponent implements OnInit {
  @Input() trip: any;
  @Input() source?: any;
  @Output() closeModal = new EventEmitter<any>();
  @ViewChild("canvas", { static: true }) canvas!: ElementRef;
  sig!: SignaturePad;
  isSubmitted: boolean = false;
  isEmptySignature: boolean = false;

  constructor(
    private billingService: BillingService,
    private uploadService: UploadService,
    private tripService: TripService
  ) { }

 ngOnInit() {
  this.setSignaturePad();
}

setSignaturePad() {
  const canvasEl = this.canvas.nativeElement;
  canvasEl.style.backgroundColor = 'transparent';

  this.sig = new SignaturePad(canvasEl, {
    penColor: 'rgb(32, 159, 188)',
    backgroundColor: 'rgba(0,0,0,0)' // transparent
  });
}





  async onSave() {
    this.isSubmitted = true;
    this.isEmptySignature = false;
    if (this.sig.isEmpty()) {
      this.isEmptySignature = true;
      return;
    }
    const signatureBase64 = this.sig.toDataURL();
    const file = base64ToFile(signatureBase64, 'signature.png');
    const section = this.source === 'driver' ? 'drivers': 'trips';
    const uploadRes: any = await firstValueFrom(
      this.uploadService.uploadImageToServer(file, section)
    );
    if (uploadRes && uploadRes.fileUrl) {
      if(this.source === 'trips'){
        this.tripService.signatureUpdate({ signature: uploadRes.fileUrl }, this.trip.id).subscribe(data => {
          if (data) {
            this.closeModal.emit(data);
          }
        });
      }else if(this.source === 'fundingsourceBilling'){
        this.billingService
          .adjustFundingSourceTrip({ signature: uploadRes.fileUrl }, true, this.trip.id)
          .subscribe(data => {
            if (data) {
              this.closeModal.emit(data);
            }
          });
      }else if(this.source === 'driver'){
        this.closeModal.emit({ signature: uploadRes.fileUrl });
      }
      else{
        this.billingService
          .billingSignatureUpdate({ signature: uploadRes.fileUrl }, true, this.trip.id)
          .subscribe(data => {
            if (data) {
              this.closeModal.emit(data);
            }
          });
      }
    }
  }

  onClear(){
    this.sig.clear();
  }

  onCloseModal() {
    this.closeModal.emit();
  }

}
